/**
 * Copyright 2025-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { ApolloError } from "@apollo/client";
import {
  ReportType,
  useCreateResourceUpdatesReportMutation,
} from "~/generated/graphql";
import { showError, showInfo } from "~/services/toast";

export function useCreateResourceUpdatesReport() {
  const [mutate, { loading }] = useCreateResourceUpdatesReportMutation({
    onCompleted: () => {
      showInfo(
        'Your CSV report is being generated. You can track the progress in the "Reports" section of the “Resources” tab.',
        { autoClose: 5000 }
      );
    },
    onError: (error: ApolloError) => {
      showError(
        error.message || "Failed to generate the report. Please try again."
      );
    },
  });

  const createResourceUpdatesReport = (input: {
    resourceId: string;
    startDate: string;
    endDate: string;
  }) => {
    mutate({
      variables: {
        reportType: ReportType.ResourcePackagesComplianceCsvExport,
        resourceId: input.resourceId,
        startDate: input.startDate,
        endDate: input.endDate,
      },
    });
  };

  return [createResourceUpdatesReport, loading] as const;
}
